import React from 'react';
import FinanceApprovalPageHeader from './components/ApprovalPageHeader';
import ModuleCards from './components/ModuleCards';

const StudentFinanceApproval = () => {
    return ( 
        <>
        <FinanceApprovalPageHeader/>
        <ModuleCards/>
        </>
     );
}
 
export default StudentFinanceApproval;